import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class CurrentFeed extends Helper {
  @service feeds;

  compute(_positionalParams, hash = {}) {
    return this.feeds.current;
  }
}
